var React = require('react');
var Checkbox = require('../../../components/Checkbox');
var FileSaver = require('file-saver');
var truncate = require('../../../helpers/truncate').truncate;
var Dialog = require('../../../components/Dialog');
require('./DownloadDialog.css');

class DownloadDialog extends React.Component {
  constructor(props) {
    super(props);
    this.isAllChaptersChecked = this.isAllChaptersChecked.bind(this);
    this.downloadPdf = this.downloadPdf.bind(this);
    this.triggerDownload = this.triggerDownload.bind(this);
    this.getLink = this.getLink.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleGeneratePdf = this.handleGeneratePdf.bind(this);
    this.state = {
      hasGenerated:false
    }
  }

  getLink() {
    return this.props.downloadUrl + '&c=' + this.props.selectedChapters.join();
  }

  handleGeneratePdf(e) {
    e.preventDefault();
    let isChapterSelected = false;
    this.props.sections.forEach(chapter => {
      if(chapter.toPdf) {
        isChapterSelected = true;
      }
    });
    if(!isChapterSelected) {
      return false;
    }
    this.props.showPdfProgress();

    if(this.isAllChaptersChecked()) {
      this.downloadPdf();
      return;
    }

    var hasGenerated = false;
    var timerHit = false;
    var blob;
    var url = this.getLink(this.props.sections);
	
	document.dispatchEvent(new CustomEvent('pubr-download--chapter', { detail: { url: url } }));

    fetch(url, { method: 'GET', credentials: "same-origin" })
      .then(response => response.blob())
      .then(data => {
        setTimeout(() => {
          hasGenerated = true;
          this.setState({
            hasGenerated: true
          });
          blob = new Blob([data], { type: "application/pdf" });
          this.triggerDownload(blob, hasGenerated, timerHit);
        }, 2000);
    });

    setTimeout(() => {
      timerHit = true;
      this.triggerDownload(blob, hasGenerated, timerHit);
    }, 1000);
  }
  
  handleCheckChange(chapter, select) {
    var pdfsource = this.getLink(this.props.sections);
    this.props.chapterToPdf({ id: chapter, src: pdfsource, toPdf: select });
  }

  handleAllCheckChange(select) {
    var pdfsource = this.getLink(this.props.sections);
    this.props.selectedChapters = [];
    this.props.sections.forEach(chapter => {
      this.props.chapterToPdf({ id: chapter.sectionId, src: pdfsource, toPdf: select })
    });
  }

  handleClose(e) {
    this.props.hidePdfProgress();
    this.props.toggleDownloadDialog();
  }

  downloadPdf() {

    var hasGenerated = false;
    var timerHit = false;
    var blob;
    var url = this.props.downloadUrl;
	
	document.dispatchEvent(new CustomEvent('pubr-download--full', { detail: { url: url } }));
	
    fetch(url, { method: 'GET', credentials: "same-origin" })
      .then(response => response.blob())
      .then(data => {
        hasGenerated = true;
        this.setState({
          hasGenerated: true
        });
        blob = new Blob([data], {type: "application/pdf"});
        this.triggerDownload(blob, hasGenerated, timerHit);
    });

    setTimeout(() => {
      timerHit = true;
      this.triggerDownload(blob, hasGenerated, timerHit);
    }, 1000);
  }

  triggerDownload(blob, hasGenerated, timerHit) {
    if (!timerHit || !hasGenerated)
      return;

    FileSaver.saveAs(blob, this.props.filename);
  }

  isAllChaptersChecked() {
    for(let i = 0; i < this.props.sections.length; i++) {
      if(!this.props.sections[i].toPdf) {
        return false;
      }
    }
    return true;
  }

    render() {
    if(!this.props.expanded) return null;
        var item = this.props.sections.map((chapter) => {
            if (chapter.isExternalPdf) {
                return;
            }
      return (
        <li key={chapter.sectionId}>
          <Checkbox
            label={truncate(chapter.sectionHeading.toString(), 60, '...')}
            checked={this.props.downloadFullPdf || chapter.toPdf}
            onCheckChange={() => this.handleCheckChange(chapter.sectionId, !chapter.toPdf)} />
        </li>
      );
    })

    var isAllChecked = this.props.downloadFullPdf || this.isAllChaptersChecked();

    if (this.props.downloadFullPdf && !this.props.downloadPdfProgess) {
      this.handleAllCheckChange(this.props.downloadFullPdf);
      this.handleGeneratePdf({ preventDefault: () => { } });
    }

return (
      <Dialog outsideClickHandler={this.handleClose}>
          <button onClick={this.handleClose} className="pubr-download__close">x</button>
        <strong className="pubr-download__heading">{this.props.readerGui.downloadPublicationText}</strong>
          {this.props.downloadFullPdf}

          {this.props.downloadPdfProgess &&
            <div className="pubr-download__inner">
                <div className="pubr-download__inner__intro">
                  
                  {this.state.hasGenerated ? <div className="pubr-done"></div> : <div className="pubr-spinner"></div>}                  
                  <p>
                    {this.state.hasGenerated ? this.props.readerGui.downloadPublicationStartedText : this.props.readerGui.downloadPublicationOngoingText }
                  </p>
                </div>
                
                <div className="pubr-download__actions">
                <button onClick={this.handleClose} className="pubr-action">{this.props.readerGui.closeText}</button>
                </div>
            </div>
          }
          {!this.props.downloadPdfProgess &&
            <div className="pubr-download__inner">
              <div className="pubr-download__inner__intro">
              <Checkbox
                    label={this.props.readerGui.selectAllText}
                  className="pubr-download__inner__all"
                  checked={isAllChecked}
                  onCheckChange={() => { this.handleAllCheckChange(!isAllChecked)}} />
              </div>
              <ol className="pubr-download__inner__chapters">
              {item}
              </ol>
              <div className="pubr-download__actions">
                <button onClick={this.handleGeneratePdf} className="pubr-download__actions__download pubr-action">{this.props.readerGui.downloadText}</button>
              </div>
            </div>
          }
        </Dialog>
    )

  }
}

module.exports = DownloadDialog;


// WEBPACK FOOTER //
// ./src/modules/download/components/DownloadDialog.js